module.exports = "images/header_arrow.png";